import useMods from '@hooks/useMods';

import PropTypes from 'prop-types';
import React from 'react';

const AccordionBody = ({ children, mods={}, className: classNameTail }) => {
    const { className } = useMods(AccordionBody, { mods });

    return (
        <div
            className={ className + (classNameTail ? ' ' + classNameTail : '') }
        >
            { children }
        </div>
    );
};

AccordionBody.displayName = 'Accordion__Body';

AccordionBody.propTypes = {
    children: PropTypes.node,
    mods: PropTypes.object
};

export default AccordionBody;
